<template>
  <IonToolbar color="white" class="border-b-2 border-gray-300">
    <HeaderBackButton @click.stop="goBackToPropertyDetails">{{ selectedProperty.property?.name }} </HeaderBackButton>
    <div class="text-2xl text-gray-900 font-bold">Gateway</div>
  </IonToolbar>
</template>

<script setup lang="ts">
import HeaderBackButton from '@/components/forms/HeaderBackButton.vue';
import { useSelectedProperty } from '@/stores/selected-property.store';
import { IonToolbar, useIonRouter } from '@ionic/vue';

const selectedProperty = useSelectedProperty();
const router = useIonRouter();

function goBackToPropertyDetails() {
  return router.navigate(`/property/${selectedProperty.propertyId}`, 'back', 'push');
}
</script>

<style scoped></style>
